// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"e44acf9d","498":"a98194e0","513":"4d44f943","545":"e729d7a0"}[chunkId] + ".chunk.js";
};